import React, { useMemo, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DialogSection } from '@linetweet/linetweet-ui';
import { useIntl } from 'react-intl';

import { Service } from 'types';
import { ICategory, ServiceTabSelect } from '../../commons';
import { ServiceTabsSelectOption } from '../types';

type Props = {
  services: Service[];
  isDisabled?: boolean;
};

function AppointmentFormServiceSectionComponent({ services, isDisabled }: Props) {
  const intl = useIntl();
  const form = useFormContext();

  const [activeTabId, setActiveTabId] = useState(() => {
    let defaultTabId = '';
    const servicesValue = form.getValues('services');
    if (servicesValue.length > 0) {
      defaultTabId = servicesValue[0].tabId;
    } else if (services.length > 0) {
      defaultTabId = services[0].category;
    }
    return defaultTabId;
  });

  const serviceInputProps = useMemo(() => {
    const tabs = services.reduce((acc: ICategory[], service) => {
      if (acc.find((category) => service.category === category.id)) {
        return acc;
      }
      acc.push(
        {
          id: service.category,
          name: intl.formatMessage({ id: `service.${service.category}` }),
        },
      );
      return acc;
    }, []);

    const options = services.map(
      (service): ServiceTabsSelectOption => ({
        label: intl.formatMessage({ id: service.name }),
        value: service.id,
        name: service.name,
        tabId: service.category,
        extra: { ...service },
      }),
    );

    return {
      tabs,
      options,
    };
  }, [services]);

  return (
    <DialogSection
      title={intl.formatMessage({ id: 'service.service' })}
    >
      <Controller
        control={form.control}
        name="services"
        render={({ field }) => (
          <ServiceTabSelect
            {...serviceInputProps}
            exclusive
            isDisabled={!!isDisabled}
            value={field.value}
            onServiceChange={field.onChange}
            onTabChange={setActiveTabId}
            activeTabId={activeTabId}
          />
        )}
      />
    </DialogSection>
  );
}

AppointmentFormServiceSectionComponent.defaultProps = {
  isDisabled: false,
};

export const AppointmentFormServiceSection = React.memo(AppointmentFormServiceSectionComponent);
